export class SpecialSensorValue{

	constructor(private replacement:string,private icon?:string){
	}
	
	hasIcon():boolean{

		return this.icon != undefined;
		
	}
	
	getIcon():string{

		if(this.icon){
			return this.icon;
		}

		return '';

	}

	getReplacement():string{

		if(this.replacement){
			return this.replacement;
		}

		return '';
	}

}